<template>
  <div class="animated fadeIn">
    <b-row v-if="loading">
      <b-col md="6">
        <atom-spinner
          :animation-duration="1000"
          :size="60"
          color="#ff1d5e"
          class="float-right my-5"
        />
      </b-col>
    </b-row>
    <div v-if="!loading">
      <component-header
        title="Create Commission"
        :hasSearch="false"
        :hasReload="false"
        :hasCreate="false"
        :hasback="true"
        @back-press="$router.push('view-commission')"
      />
      <ValidationObserver v-slot="{ invalid }" ref="observer">
        <b-row>
          <b-col>
            <transition name="fade">
              <b-card
                border-variant="info"
                header-bg-variant="primary"
                header-text-variant="white"
                class="card-wrap"
                style="min-height: 600px"
              >
                <b-row>
                  <b-col md="5" class="my-1">
                    <label class="label"> Select Commission </label>
                    <br />
                    <ValidationProvider
                      rules="required"
                      v-slot="{ errors }"
                      name="Commission  To"
                    >
                      <ebSelect
                        id="Commission"
                        :options="commissionList"
                        v-model="inputObject.commissionrule"
                        label="label"
                        placeholder="Select Commission"
                        class="w-100"
                      ></ebSelect>
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                  <b-col md="5" class="my-1">
                    <label class="label">Commission Rate </label>
                    <br />
                    <ValidationProvider
                      rules="required|between:0,100"
                      v-slot="{ errors }"
                      name="Commission value Percentage"
                    >
                      <c-input
                        :inputId="`rate`"
                        inputType="number"
                        required
                        labelText="Rate *"
                        v-model="inputObject.rate"
                      />
                      <span class="validate-error">{{ errors[0] }}</span>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <br />
                <br />
                <div class="p-1 text-center">
                  <button
                    type="submit"
                    @click="submitCommission"
                    class="btn btn-primary"
                    :disabled="invalid"
                  >
                    Submit
                  </button>
                </div>
              </b-card>
            </transition>
          </b-col>
        </b-row>
      </ValidationObserver>
    </div>
  </div>
</template>
 
<script>
import ebSelect from "@/components/FormElements/Select.vue";
import ebButton from "@/components/FormElements/Button";
import { mapGetters } from "vuex";
import cInput from "@/components/Common/CustomInput";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import ComponentHeader from "@/components/componentNewHeader";
import { AtomSpinner } from "epic-spinners";
export default {
  name: "CommissionCreate",
  components: {
    ebSelect,
    ebButton,
    ValidationProvider,
    ValidationObserver,
    cInput,
    ComponentHeader,
    AtomSpinner,
  },
 
  data: () => {
    return {
      loading: false,
      inputObject: {
        commissionrule: "",
        rate: "",
      },
    };
  },
  computed: {
    ...mapGetters({
      getFetchCommissionRule: "commission/GetFetchCommissionRule",
      partnerAllData: "partner/GetPartnerData",
    }),
 
    commissionList() {
      let data = this.getFetchCommissionRule;
      if (Array.isArray(data) && data.length > 0) {
        return data.map((d) => ({
          label: d.ruleName,
          value: d._id,
        }));
      }
      return [];
    },
  },
  methods: {
    isValid() {
      const isValid = this.$refs.observer.validate();
      this.$emit("isValid", isValid);
      return isValid;
    },
    async submitCommission() {
      {
        const isValid = await this.isValid();
 
        if (!isValid) return;
        let payload = {
          user: {
            id: this.partnerAllData._id,
            name: this.partnerAllData.authentication.userName,
            email: this.partnerAllData.email,
            phone: this.partnerAllData.phone,
            userType: this.partnerAllData.category,
          },
          collectedBy: {
            id: this.partnerAllData?.tenant,
            userType: "TENANT",
          },
          commissionRule: this.inputObject.commissionrule.value,
          rate: this.inputObject.rate / 100,
        };
 
        await this.$store
          .dispatch("commission/createCommissionRuleAssign", payload)
          .then((result) => {
            this.$swal({
              title: "Successful",
              text: "Commission Rule Assign Successfully!",
              type: "success",
            });
            this.$router.push({
              name: "view-commission",
              params: { id: this.partnerAllData?._id },
            });
          })
          .catch((err) => {
            this.$swal({
              title: "Sorry",
              text: "Unable to Assign Commission Rule",
              type: "error",
            });
          });
      }
    },
  },
  async mounted() {
    this.loading = true;
    await this.$store.dispatch("commission/fetchCommissionRuleAction");
    this.loading = false;
  },
};
</script>
<style>
.label {
  font-family: Arial;
  font-weight: bold;
}
</style>
 
 